const PostsSectionSkeleton = () => {
  return (
    <div className="w-full">
      {/* ✅ Skeleton for Category Tabs */}
      <div className="mb-4 flex space-x-3 overflow-x-auto border-b pb-2">
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="h-8 w-20 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"
          ></div>
        ))}
      </div>

      {/* ✅ Skeleton for Articles List */}
      <div className="space-y-4">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="h-16 w-full animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"
          ></div>
        ))}
      </div>
    </div>
  );
};

export default PostsSectionSkeleton;
